import useDisplayFirstStatsPanel from '@/utils/hooks/firstStats/useDisplayFirstStatsPanel';

// Components
import ModalBlockContent from '@/components/base/Modal/ModalBlockContent';
import FirstStats from '@/components/composite/FirstStats';

const ModalFirstStats = () => {
    const { hideFirstStatsEmptyState, setHideFirstStatsEmptyState } = useDisplayFirstStatsPanel();

    if (hideFirstStatsEmptyState) {
        return null;
    }

    return (
        <ModalBlockContent size="nav_fit">
            <ModalBlockContent.Body className="flex flex-col md:flex-row">
                <FirstStats start={() => setHideFirstStatsEmptyState(true)} />
            </ModalBlockContent.Body>
        </ModalBlockContent>
    );
};

export default ModalFirstStats;
